import { useGetTrackingEventData } from '../../common/hooks/useQueryParams';
import { DEFAULT_LOAN_DATA } from './constants';
import { LoanData } from './types';
import LoanFormStepper from './workflow/LoanFormStepper';

interface LoanFormProps {
  loanDataInput?: LoanData;
}

function LoansFormComponent({ loanDataInput }: LoanFormProps) {
  const { rpId, source, utmSource } = useGetTrackingEventData();
  const loanData = loanDataInput ?? DEFAULT_LOAN_DATA;
  const enrichedLoanData: LoanData = {
    ...loanData,
    recruitmentPartnerId: rpId,
    source: (source || utmSource) ?? undefined,
  };

  return <LoanFormStepper loanData={enrichedLoanData} />;
}

export default LoansFormComponent;
